<div class="container flex justify--center">
  <dgx-components-button
    class="compare-footer"
    variant="primary"
    [disabled]="offers?.length === 0"
    (clicked)="onClick()"
    >Compare models {{ offers?.length }}/2</dgx-components-button
  >
</div>
